import { useState, useCallback } from 'react';

/**
 * @typedef {object} ExpandableRowsReturn
 * @property {{[key: string]: boolean}} expandedRows - Object mapping row IDs to expanded state
 * @property {(rowId: string, isExpanded: boolean) => void} handleRowExpand - Function to handle row expansion
 */

/**
 * Hook to manage the expanded state of rows in the forecasting grid
 * @returns {ExpandableRowsReturn} Object containing expandedRows state and handleRowExpand function
 */
export const useExpandableRows = () => {
  const [expandedRows, setExpandedRows] = useState({});

  const handleRowExpand = useCallback((rowId, isExpanded) => {
    setExpandedRows((prev) => {
      if (isExpanded) {
        return { [rowId]: true };
      }

      return Object.entries(prev)
        .filter(([id]) => id !== rowId)
        .reduce((acc, [id, value]) => ({ ...acc, [id]: value }), {});
    });
  }, []);

  return { expandedRows, handleRowExpand };
};

export default useExpandableRows;
